import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'strLimit',
  standalone: false,
})
class StrLimit implements PipeTransform {
  transform(input: string, limit: number): string {
    if (!input || input.length <= limit) {
      return input;
    }
    return `${input.substring(0, limit)}...`;
  }
}

export { StrLimit };
